export default function HowWeHelpSection() {
  return (
    <section id="how-we-help" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-800 px-4 py-2 rounded-full text-sm font-bold mb-6">
            Our Foreclosure Prevention Solution
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            How We Help You Avoid Foreclosure
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We specialize in buying foreclosed properties and homes at risk of foreclosure in El Paso. Our fast, simple process helps you avoid foreclosure, protect your credit, and move forward with dignity.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/02b387e2c63d4603e5c6ca1f3d99da5d.jpg" 
              alt="How we help homeowners avoid foreclosure in El Paso" 
              className="w-full h-auto rounded-2xl shadow-xl"
            />
          </div>

          <div>
            <h3 className="text-3xl font-black text-gray-900 mb-6">Why Choose TRex RE LLC - The Texas Property buyers?</h3>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-flashlight-fill text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">Lightning-Fast Closings</h4>
                  <p className="text-base text-gray-700 leading-relaxed">
                    We can close in as little as 7 days, giving you cash before your foreclosure sale date. Traditional sales take 60-90 days - time you don't have when trying to avoid foreclosure.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-hand-coin-fill text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">Cash Offers - No Financing Contingencies</h4>
                  <p className="text-base text-gray-700 leading-relaxed">
                    We buy foreclosed properties with cash, so there's no risk of buyer financing falling through. You get a guaranteed sale and can avoid foreclosure with certainty.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-tools-fill text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">Buy Houses in Any Condition</h4>
                  <p className="text-base text-gray-700 leading-relaxed">
                    Don't waste time or money on repairs. We buy foreclosed properties as-is, whether they need minor updates or major renovations. You can avoid foreclosure without fixing anything.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-file-list-3-fill text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">We Handle All the Paperwork</h4>
                  <p className="text-base text-gray-700 leading-relaxed">
                    Our team manages all documentation, works directly with your lender, and handles the entire closing process. You can avoid foreclosure without the stress of complicated paperwork.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-percent-fill text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">No Fees, No Commissions</h4>
                  <p className="text-base text-gray-700 leading-relaxed">
                    Unlike traditional sales with 6% realtor commissions, closing costs, and repair expenses, we cover all costs. You keep more money when you avoid foreclosure by selling to us.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-shield-check-fill text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">Protect Your Credit Score</h4>
                  <p className="text-base text-gray-700 leading-relaxed">
                    Selling before foreclosure minimizes credit damage compared to a completed foreclosure. You can avoid foreclosure consequences and maintain better financial standing for your future.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-12 text-white">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-5xl font-black mb-3">24hrs</div>
              <p className="text-lg font-semibold">Cash Offer in Your Hands</p>
            </div>
            <div>
              <div className="text-5xl font-black mb-3">7 Days</div>
              <p className="text-lg font-semibold">Close and Get Your Money</p>
            </div>
            <div>
              <div className="text-5xl font-black mb-3">$0</div>
              <p className="text-lg font-semibold">Fees or Commissions</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}